<div class="login-page">
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h1>{{ 'login.login' | translate }}</h1>
      </div>

      <form (ngSubmit)="onSubmit()" class="login-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'login.loginField' | translate }}</mat-label>
          <input matInput type="text" id="username" [value]="username()"
            (input)="username.set($any($event.target).value)" [disabled]="isLoading()" required
            autocomplete="username" />
        </mat-form-field>
        <a routerLink="/recoverpassword" class="forgot-password-link">{{ 'login.forgotPassword' | translate }}</a>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'login.password' | translate }}</mat-label>

          <input matInput [type]="showPassword() ? 'text' : 'password'" id="password" [value]="password()"
            (input)="password.set($any($event.target).value)" [disabled]="isLoading()" required
            autocomplete="current-password" />
          <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()" [disabled]="isLoading()">
            <mat-icon>{{ showPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </mat-form-field>

        @if (sessionExpired()) {
        <div class="field-warning">{{ 'login.sessionExpired' | translate }}</div>
        }
        @if (errorMessage()) {
        <div class="field-error">{{ errorMessage() }}</div>
        }

        <button type="submit" class="btn-login" [disabled]="isLoading()">
          @if (isLoading()) {
          <mat-spinner diameter="20" color="accent"></mat-spinner>
          {{ 'login.loggingIn' | translate }}
          } @else {
          {{ 'login.loginButton' | translate }}
          }
        </button>
      </form>

      <div class="login-footer">
        <p>{{ 'login.noAccount' | translate }} <a
            href="https://sso.agrosmart.gov.kg/register?clientKey=agro_tariff_quota$supplier&returnUrl=https://quota.agro.gov.kg/&appName=Поставщик&role=ps">{{
            'login.register' | translate }}</a></p>
        <a routerLink="/" class="back-link">← {{ 'login.backToHome' | translate }}</a>
      </div>
      <div class="ekyzmat-container">
        <p>{{ 'login.ekyzmatLogin' | translate }}</p>
        <button type="button" class="btn-ekyzmat" (click)="onEkyzmatLogin()" [disabled]="isLoading()">
          @if (isLoading()) {
          <mat-spinner diameter="20" color="accent"></mat-spinner>
          EKYZMAT
          } @else {
          EKYZMAT
          }
        </button>
      </div>
    </div>
  </div>